import styled from "styled-components";

export const PaymentFormContainer = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid grey;
  padding: 0 12px;
  box-shadow: 0 0 6px 2px grey;
  margin-top: 4%;
`;

export const FormContainer = styled.div`
  height: 100px;
  min-width: 500px;
`;
